import { useEffect, useState } from "react";
import api from "../lib/api";
import DataTable from "../components/DataTable";
import PageHeader from "../components/PageHeader";
import { Badge, statusVariant } from "../components/Badge";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { fmtBDT } from "../lib/format";

export default function Bets({ onlyPending = false }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const params = onlyPending ? { status: "pending" } : {};
    const { data } = await api.get("/bets", { params });
    setRows(data);
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [onlyPending]);

  const settle = async (row, status) => {
    await api.patch(`/bets/${row.id}`, { status });
    toast.success(`Bet marked ${status}`);
    load();
  };

  return (
    <div data-testid="bets-page">
      <PageHeader
        title={onlyPending ? "Pending Bets" : "Bet List"}
        subtitle={onlyPending ? "Bets awaiting settlement" : "All bets placed across games"}
      />
      <DataTable
        testId="bets-table"
        loading={loading}
        rows={rows}
        columns={[
          { key: "player_name", label: "Player" },
          { key: "game", label: "Game" },
          { key: "stake", label: "Stake", align: "right", render: (r) => fmtBDT(r.stake) },
          { key: "odds", label: "Odds", align: "right", render: (r) => Number(r.odds).toFixed(2) },
          { key: "potential_win", label: "Potential", align: "right", render: (r) => fmtBDT(r.potential_win) },
          { key: "status", label: "Status", render: (r) => <Badge variant={statusVariant(r.status)}>{r.status}</Badge> },
          { key: "created_at", label: "Placed", render: (r) => new Date(r.created_at).toLocaleString("en-GB") },
        ]}
        actions={(row) => row.status === "pending" ? (
          <div className="flex items-center gap-1 justify-end">
            <button onClick={() => settle(row, "won")} className="h-8 px-2 inline-flex items-center gap-1 text-xs border border-emerald-200 text-emerald-700 rounded-sm hover:bg-emerald-50" data-testid={`bet-won-${row.id}`}>
              <Check size={13} /> Won
            </button>
            <button onClick={() => settle(row, "lost")} className="h-8 px-2 inline-flex items-center gap-1 text-xs border border-red-200 text-red-700 rounded-sm hover:bg-red-50" data-testid={`bet-lost-${row.id}`}>
              <X size={13} /> Lost
            </button>
          </div>
        ) : null}
      />
    </div>
  );
}
